import { useTranslation } from "react-i18next";

import { Button } from "src/core/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/core/components/ui/dialog";
import { Diligence } from "src/core/gql/graphql";
import { useDeleteDiligence } from "src/core/hooks/folder/useDeleteDiligence";

type DeleteDiligenceModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  diligence: Diligence | null;
  setDiligenceToEdit: (diligence: Diligence | null) => void;
};

export const DeleteDiligenceModal = ({
  open,
  setOpen,
  diligence,
  setDiligenceToEdit,
}: DeleteDiligenceModalProps) => {
  const { t } = useTranslation();

  const { handleDelete, isLoading } = useDeleteDiligence(setOpen, diligence, setDiligenceToEdit);

  if (!diligence) {
    return null;
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        hideCloseButton
        onInteractOutside={(e) => e.preventDefault()}
        className="w-[440px]"
      >
        <DialogHeader>
          <DialogTitle className="uppercase">{t("form.deleteDiligence.modal.title")}</DialogTitle>
          <DialogDescription className="sr-only">
            {t("form.deleteDiligence.modal.description")}
          </DialogDescription>
        </DialogHeader>

        <DialogDescription style={{ whiteSpace: "pre-line" }}>
          {t("form.deleteDiligence.modal.description")}
        </DialogDescription>

        <DialogFooter className="flex flex-row justify-center gap-x-40 border-t border-border pt-10 sticky bottom-0 bg-gray-xlight h-fit">
          <Button
            variant="link"
            onClick={(event) => {
              event.preventDefault();
              setOpen(false);
              setDiligenceToEdit(null);
            }}
            disabled={isLoading}
          >
            {t("global.form.cancel")}
          </Button>
          <Button
            variant="default"
            className="ml-[20px]"
            onClick={handleDelete}
            loading={isLoading}
          >
            {t("form.deleteDiligence.modal.submit")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
